/**
 * The environment bar, left of the toolbar: one button per environment of the plugins on in
 * this project (Coding, Writing, UI/UX...), the one this page works in pressed. Plugins bring
 * them (`state/environments.ts`), so a new environment plugin shows here once it is on. With
 * none on, it leads to the Plugins window.
 */
import { For, Show, type JSX } from "solid-js";
import { useApp } from "./context";

/** The environment bar. */
export function EnvironmentBar(): JSX.Element {
  const { environments, wm } = useApp();
  return (
    <div class="envbar" id="envbar" role="toolbar" aria-label="Environments">
      <Show
        when={environments.list().length}
        fallback={
          <button type="button" class="env-button" id="envbar-plugins" title="Turn on a plugin bringing an environment, such as Coding" onClick={() => wm.open("plugins")}>
            Choose plugins
          </button>
        }
      >
        <For each={environments.list()}>
          {(e) => (
            <button
              type="button"
              class="env-button"
              data-env={e.id}
              title={e.summary || e.label}
              aria-pressed={environments.current()?.id === e.id}
              onClick={() => environments.choose(e.id)}
            >
              {e.label}
            </button>
          )}
        </For>
      </Show>
    </div>
  );
}
